import React, { useState, useEffect } from 'react';
import { Modal, Button, FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AlertComponent from '../../../../../../components/Alert';
import SelectVirtualized from '../../../../../../components/Select/Virtualized';
import { languagesAdd } from '../../../../../../services/endpoints/languages';
import { getErrorMessage } from '../../../../../../utils/helper';

const AddLanguageModal = ({ data, onHide, onSubmit }) => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [selectOptions, setSelectedOptions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(null)

  useEffect(() => {
    const options = data.map((item) => ({
      label: item.name,
      value: item.code,
    }));
    setSelectedOptions(options)
    if (options.length) {
      setSelectedLanguage(options[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmitForm = async () => {
    setLoading(true);
    try {
      const code = selectedLanguage.value;
      const response = await languagesAdd(code);
      if (response.success) {
        onSubmit()
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Add new language</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading && <div className="modal-loader-small" />}
        {error && <AlertComponent text={error} type="danger" />}
        <AlertComponent text="No translations are included for this language.<br />Please add your own translations." type="warning" />
        <FormGroup>
          <ControlLabel>Language</ControlLabel>
          <SelectVirtualized
            components={{ IndicatorSeparator: null }}
            onChange={setSelectedLanguage}
            noOptionsMessage={() => 'Language not found'}
            hideSelectedOptions={false}
            value={selectedLanguage}
            options={selectOptions}
            name="language"
            placeholder="Choose language"
          />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button
          disabled={isLoading}
          bsStyle="primary"
          type="submit"
          onClick={onSubmitForm}
        >
          <span>Save changes</span>
        </Button>
        <Button
          disabled={isLoading}
          onClick={onHide}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </>
  );
};

AddLanguageModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddLanguageModal;
